const ResizeHandle =
  '<svg class="ltr" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M20 0 0 20h2L20 2V0ZM20 6 6 20h2L20 8V6ZM20 12l-8 8h2l6-6v-2Z" fill="#000"/></svg><svg class="rtl" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="m0 0 20 20h-2L0 2V0ZM0 6l14 14h-2L0 8V6ZM0 12l8 8H6l-6-6v-2Z" fill="#000"/></svg>';

export default ResizeHandle;
